import React, { ReactElement } from "react";

export default function AreaDivider(): ReactElement {
  return <div className="top-0 z-10 h-full w-px bg-companyGrey" />;
}
